import { Skeleton } from "@/components/ui/skeleton";

export function SkeletonContent() {
  return (
    <div className="flex flex-col gap-8 container mx-auto">
      <div className="flex flex-col space-y-3">
        <Skeleton className="h-[20px] w-full rounded-sm" />
        <Skeleton className="h-[20px] w-full rounded-sm" />
        <Skeleton className="h-[20px] w-[50%] rounded-sm" />
      </div>
      <div className="flex flex-col space-y-3">
        <Skeleton className="h-[20px] w-full rounded-sm" />
        <Skeleton className="h-[20px] w-full rounded-sm" />
        <Skeleton className="h-[20px] w-[50%] rounded-sm" />
      </div>
      <div className="flex flex-col space-y-3">
        <Skeleton className="h-[20px] w-full rounded-sm" />
        <Skeleton className="h-[20px] w-full rounded-sm" />
        <Skeleton className="h-[20px] w-[50%] rounded-sm" />
      </div>
    </div>
  );
}
